/* tslint:disable */
/* eslint-disable */
/**
 * Carrot Config Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The "DashboardTileType" Enum
 * @export
 */
export const DashboardTileType = {
    KeyNumbers: 'KEY_NUMBERS',
    KeyNumbersPerCategory: 'KEY_NUMBERS_PER_CATEGORY',
    WasteTypesInUse: 'WASTE_TYPES_IN_USE',
    RecyclingRateOverTime: 'RECYCLING_RATE_OVER_TIME',
    DevelopmentInWasteTypes: 'DEVELOPMENT_IN_WASTE_TYPES',
    WasteContribution: 'WASTE_CONTRIBUTION',
    WasteTypeDistribution: 'WASTE_TYPE_DISTRIBUTION',
    InfrastructureSummary: 'INFRASTRUCTURE_SUMMARY'
};
export function instanceOfDashboardTileType(value) {
    for (const key in DashboardTileType) {
        if (Object.prototype.hasOwnProperty.call(DashboardTileType, key)) {
            if (DashboardTileType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function DashboardTileTypeFromJSON(json) {
    return DashboardTileTypeFromJSONTyped(json, false);
}
export function DashboardTileTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DashboardTileTypeToJSON(value) {
    return value;
}
//# sourceMappingURL=DashboardTileType.js.map